import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Material } from '../../material';

@Component({
    selector: 'kiene-heimtier-kunde-dialog',
    templateUrl: './artikel-excel-import-preview-dialog.component.html',
    styleUrls: ['./artikel-excel-import-preview-dialog.component.scss'],
})
export class ArtikelExcelImportPreviewDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<ArtikelExcelImportPreviewDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public artikel: Material,
    ) {}
}
